import { IconButton, Toast } from '@lexhero/park-ui';
import { XIcon } from 'lucide-react';
import styles from './toastContainerParkUi.module.css';

export interface toastContext {
    id: string;
    title: string;
    description?: string;
    type: 'info' | 'success' | 'error' | 'warning' | 'neutral';
    duration?: number;
    removeDelay?: number;
    gap?: number;
    stacked?: boolean;
}

export const toaster = Toast.createToaster({
    placement: 'top-center',
    overlap: true,
    gap: 16,
});

export default function ToastContainerParkUi() {
    return (
        <Toast.Toaster toaster={toaster}>
            {(toast: toastContext) => (
                <Toast.Root key={toast.id} className={styles.toastContainer}>
                    <Toast.Title>{toast.title}</Toast.Title>
                    <Toast.Description>{toast.description}</Toast.Description>
                    <Toast.CloseTrigger asChild>
                        <IconButton
                            size="sm"
                            variant="link"
                            data-cy="toast-close"
                        >
                            <XIcon />
                        </IconButton>
                    </Toast.CloseTrigger>
                </Toast.Root>
            )}
        </Toast.Toaster>
    );
}
